(() => {
  function init() {
    var panelA = document.querySelector('[id*="__custom_recommendations_"]');
    var panelB = document.querySelector('[id$="__product-recommendations"]');
    var panelC = document.querySelector('.recently-view-section');

    if (!panelA || !panelB) return;

    var labelA = 'You May Like';
    var labelB = 'Also Viewed';
    var labelC = 'Recently Viewed';

    var tabBar = document.createElement('div');
    tabBar.className = 'gh-recs-tabs container';
    tabBar.innerHTML =
      '<button type="button" data-recs-tab="a" class="is-active">' + labelA + '</button>' +
      '<button type="button" data-recs-tab="b">' + labelB + '</button>' +
      (panelC ? '<button type="button" data-recs-tab="c" hidden>' + labelC + '</button>' : '');

    var tabC = tabBar.querySelector('[data-recs-tab="c"]');

    var panelsWrap = document.createElement('div');
    panelsWrap.className = 'gh-recs-panels';

    panelA.parentNode.insertBefore(tabBar, panelA);
    panelA.parentNode.insertBefore(panelsWrap, panelA);
    panelsWrap.appendChild(panelA);
    panelsWrap.appendChild(panelB);
    if (panelC) panelsWrap.appendChild(panelC);

    panelA.setAttribute('data-recs-panel', 'a');
    panelB.setAttribute('data-recs-panel', 'b');
    if (panelC) panelC.setAttribute('data-recs-panel', 'c');
    panelA.classList.add('is-active');

    /* Shared nav arrows: one pair, driven by whichever panel is active */
    var refPrev = panelA.querySelector('.swiper-button-prev');
    var refNext = panelA.querySelector('.swiper-button-next');

    var sharedPrev = document.createElement('button');
    sharedPrev.type = 'button';
    sharedPrev.className = 'gh-recs-shared-prev';
    sharedPrev.setAttribute('aria-label', 'Previous');
    if (refPrev) sharedPrev.innerHTML = refPrev.innerHTML;

    var sharedNext = document.createElement('button');
    sharedNext.type = 'button';
    sharedNext.className = 'gh-recs-shared-next';
    sharedNext.setAttribute('aria-label', 'Next');
    if (refNext) sharedNext.innerHTML = refNext.innerHTML;

    panelsWrap.appendChild(sharedPrev);
    panelsWrap.appendChild(sharedNext);

    function activePanel() {
      return panelsWrap.querySelector('[data-recs-panel].is-active');
    }

    sharedPrev.addEventListener('click', function () {
      var panel = activePanel();
      var btn = panel && panel.querySelector('.swiper-button-prev');
      if (btn) btn.click();
    });

    sharedNext.addEventListener('click', function () {
      var panel = activePanel();
      var btn = panel && panel.querySelector('.swiper-button-next');
      if (btn) btn.click();
    });

    function activate(target) {
      tabBar.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.recsTab === target);
      });

      panelsWrap.querySelectorAll('[data-recs-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.recsPanel === target);
      });
    }

    /* Recently viewed tab only shows once the visitor has history */
    function syncRecentTab() {
      if (!panelC || !tabC) return;
      var has = panelC.style.display !== 'none' && !!panelC.querySelector('.swiper-slide');
      if (tabC.hidden === has) tabC.hidden = !has;
      if (!has && panelC.classList.contains('is-active')) activate('a');
    }

    function syncArrowState() {
      syncRecentTab();
      var panel = activePanel();
      var realPrev = panel && panel.querySelector('.swiper-button-prev');
      var realNext = panel && panel.querySelector('.swiper-button-next');
      sharedPrev.classList.toggle(
        'swiper-button-disabled',
        !!(realPrev && realPrev.classList.contains('swiper-button-disabled'))
      );
      sharedNext.classList.toggle(
        'swiper-button-disabled',
        !!(realNext && realNext.classList.contains('swiper-button-disabled'))
      );
    }

    setInterval(syncArrowState, 300);
    /* end shared nav arrows */

    function setHeight() {
      var active = panelsWrap.querySelector('.is-active');
      if (active) {
        panelsWrap.style.minHeight = active.offsetHeight + 'px';
      }
    }

    setTimeout(setHeight, 500);
    setTimeout(syncArrowState, 500);
    window.addEventListener('resize', setHeight);

    tabBar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-recs-tab]');
      if (!btn) return;

      activate(btn.dataset.recsTab);

      if (btn.scrollIntoView) {
        try { btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (err) {}
      }

      setTimeout(setHeight, 400);
      setTimeout(syncArrowState, 450);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();